export default "__VITE_ASSET__CA8toQ6Y__"